import { useSetUrlQueryLens } from './use-set-url-query-lens';
import { useUrlQueryValue } from './use-url-query-value';

/**
 * Use a lens to get and set URL query parameters.
 *
 * Returns the current value and setter function,
 * similar to what `useState` returns.
 */
export function useUrlQueryLens(lens, navigateOptions) {
  return [useUrlQueryValue({
    lens
  }), useSetUrlQueryLens(lens, navigateOptions)];
}